<script>
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import {formatDate, sort} from "../lib/lib";
    import Alert from "../stores/alerts";
    import PageHeader from "../components/PageHeader.svelte";
    import TableHeader from "../components/TableHeader.svelte";

    const tableColumns = [
        {key: 'type', title: 'ΕΙΔΟΣ ΔΕΙΓΜΑΤΟΣ', sortable: true, sort_way: 'ASC'},
        {key: 'total', title: 'ΔΕΙΓΜΑΤΑ', sortable: true},
        {key: 'percent', title: 'ΠΟΣΟΣΤΟ', sortable: true},
    ];

    let sampleTypes = [];
    let sampleIndex = -1;
    let stats = {
        sample_types: [],
        date_from: null,
        date_to: null,
    }
    let statsResult = null

    const load = () => {
        const onSuccess = result => {
            statsResult = result
        }

        const onFailure = err => {
            console.log(err);
        };

        stats.sample_types = [];
        sampleTypes.filter(x => x.selected).map(item => {
            stats.sample_types.push(item.name);
        });

        if (!stats.sample_types.length) {
            Alert.warning("Στατιστικά δειγμάτων", "Δεν έχετε επιλέξει είδη δειγμάτων για στατιστικά!");
            return;
        }

        R.handle(R.sample.statsExcel, stats, onSuccess, onFailure, LOADER.POPUP);
    }


    const toggleSample = (index, event) => {
        sampleTypes[index].selected = event.shiftKey ? true : !sampleTypes[index].selected;
        if (sampleTypes[index].selected && event.shiftKey && sampleIndex > -1 && sampleIndex < index) {
            for (let i = sampleIndex; i <= index; i++) {
                sampleTypes[i].selected = true;
            }
        }
        sampleIndex = index;
    }

    const selectAllSampleTypes = () => {
        sampleTypes.map(item => {
            item.selected = true;
        });
        sampleTypes = sampleTypes;
    }

    const clearSearch = () => {
        sampleTypes.map(item => {
            item.selected = false;
        });
        sampleTypes = sampleTypes;
    }

    const onColumnSort = ({detail}) => {
        statsResult.samples = sort(statsResult.samples, detail.key, detail.sort_way === 'DESC');
    }


    $app.sample_types.map(item => {
        sampleTypes.push({
            name: item,
            selected: false,
        });
    });
</script>

<PageHeader title="Στατιστικά Excel"/>
<div class="row">
    <div class="col-xl-3 col-lg-4">
        <div class="panel panel-simple p-2 mb-5">

            <button class="btn btn-default btn-block mb-3" on:click={ selectAllSampleTypes }>ΕΠΙΛΟΓΗ ΟΛΩΝ</button>

            <div class="sample-types mb-3">
                {#each sampleTypes as item, index}
                    <div class="sample-type btn btn-block" class:btn-default={ !item.selected }
                         class:btn-primary={ item.selected } on:click={ (event) => toggleSample(index, event) }>
                        { item.name }
                    </div>
                {/each}
            </div>

            <label>Ημερομηνία</label>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <input type="date" class="form-control" bind:value="{ stats.date_from }">
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group">
                        <input type="date" class="form-control" bind:value="{ stats.date_to }">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-outline btn-block" on:click={ load }>ΣΤΑΤΙΣΤΙΚΑ</button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-9 col-lg-8">
        {#if statsResult}
            <table class="table table-list table-list-border table-stats mb-4">
                <tbody>
                <tr>
                    <td class="th">Είδη Δειγμάτων</td>
                    <td>{ statsResult.sample_types.length }</td>
                </tr>
                {#if statsResult.date_from || statsResult.date_to }
                    <tr>
                        <td class="th">Ημερομηνία:</td>
                        <td>
                            { formatDate(statsResult.date_from, 'd-m-y') }
                            {#if statsResult.date_to}
                                έως { formatDate(statsResult.date_to, 'd-m-y') }
                            {/if}
                        </td>
                    </tr>
                {/if}
                <tr>
                    <td class="th">Σύνολο Δειγμάτων</td>
                    <td>{ statsResult.total_samples }</td>
                </tr>
                </tbody>
            </table>
            <table class="table table-list table-list-border mb-4">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#if statsResult.samples.length}
                    {#each statsResult.samples as sample}
                        <tr class="row-hover">
                            <td>{ sample.type }</td>
                            <td>
                                {#if sample.total }{ sample.total }{/if}
                            </td>
                            <td>
                                {#if sample.percent}{ sample.percent }%{/if}
                            </td>
                        </tr>
                    {/each}
                {/if}
                </tbody>
            </table>
        {/if}
    </div>
</div>

<style>
    .sample-types .sample-type {
        padding: 4px 0;
        margin-bottom: 1px;
    }

    .table-stats .th {
        font-weight: normal;
        letter-spacing: 1px;
        color: #999;
        width: 220px;
    }
</style>

